import { EditIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Center,
  Flex,
  IconButton,
  Image,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { franchiseMapIndex } from "../../../core/constants";

const PartnerReadingCard = ({
  readingOrder,
  index,
  onClickEdit,
  onClickEditOrder,
}) => (
  <Box bg="gray.700" borderRadius="lg" overflow="hidden" mb="4">
    <Flex>
      <Image
        src={readingOrder.thumbnail}
        alt={readingOrder.title}
        height="72px"
      />
      <Center width="100%">
        <Box width="100%" px="6">
          <Link
            state={{ readingOrder }}
            to={`/partnership/reading-orders/${readingOrder.id}/comics`}
          >
            <Text fontWeight="bold">{readingOrder.title}</Text>
            <Text fontSize="small" color="gray.400">
              {!!readingOrder.years && `${readingOrder.years} • `}
              {readingOrder.comicsCount} comics •{" "}
              {franchiseMapIndex[readingOrder.franchise]} •{" "}
              {readingOrder.published ? "Published" : "Draft"}
            </Text>
          </Link>
        </Box>
      </Center>
      <Center px="6">
        <Tooltip hasArrow label="Edit order">
          <IconButton
            aria-label="Edit Order"
            icon={<HamburgerIcon />}
            onClick={() => onClickEditOrder(readingOrder.id)}
            mx="3"
          />
        </Tooltip>
        <Tooltip hasArrow label="Edit info">
          <IconButton
            aria-label="Edit Info"
            icon={<EditIcon />}
            onClick={() => onClickEdit(readingOrder.id)}
          />
        </Tooltip>
      </Center>
    </Flex>
  </Box>
);

export default PartnerReadingCard;
